import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "@redux-saga/core";

import rootSaga from "./saga/rootSaga";
import authSlice from "./slice/authSlice";
import staffSlice from "./slice/staffSlice";
import customerSlice from "./slice/customerSlice";
import tourTypeSlice from "./slice/tourTypeSlice";
import newsCategoriesSlice from "./slice/newsCategoriesSlice";
import newsSlice from "./slice/newsSlice";
import tourSlice from "./slice/tourSlice";
import searchSlice from "./slice/searchSlice";
import homeSlice from "./slice/homeSlice";
import tourDetailSlice from "./slice/tourDetailSlice";
import tourOrderSlice from "./slice/tourOrder";
import favoriteSlice from "./slice/favoriteSlice";
import rattingCommentSlice from "./slice/rattingCommentSlice";
import commentSlice from "./slice/commentSlice";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    auth: authSlice,
    staff: staffSlice,
    customer: customerSlice,
    tourType: tourTypeSlice,
    newsCategories: newsCategoriesSlice,
    news: newsSlice,
    tour: tourSlice,
    search: searchSlice,
    home: homeSlice,
    tourDetail: tourDetailSlice,
    tourOrder: tourOrderSlice,
    favorite: favoriteSlice,
    rattingComment: rattingCommentSlice,
    comment: commentSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

sagaMiddleware.run(rootSaga)

export default store
